import OptionsToggler from 'core/components/OptionsToggler'

interface Props {
  onChange: (value: string) => void
  value: string
}

const options = [
  {
    icon: 'list',
    value: 'list',
  },
  {
    icon: 'grid',
    value: 'grid',
  },
]

export default function ViewModeToggle({ onChange, value }: Props) {
  return <OptionsToggler options={options} value={value} onChange={onChange} />
}
